
export const calcGapY = (state) => {
  if (window.innerWidth < 440) {
      return (204 - 39 * 3) / 4;
  }
  if (window.innerWidth >= 440 && window.innerWidth < 736) {
      return (248 - 39 * 3) / 4;
  }
  if (window.innerWidth >= 736 && window.innerWidth < 1024) {
      return (260 - 39 * 3) / 4;
  }
  if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
      if (state) {
          return (286 - 39 * 3) / 4;
      } else {
          return (354 - 49 * 3) / 4;
      }
  }
  if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
      if (state) {
          return (364 - 50 * 3) / 4;
      } else {
          return (446 - 69 * 3) / 4;
      }
  }
  if (window.innerWidth >= 1920) {
      if (state) {
          return (448 - 70 * 3) / 4;
      } else {
          return (538 - 89 * 3) / 4;
      }
  }
}
const gcd = (a, b) => {
  while (b) {
    [a, b] = [b, a % b];
  }
  return a;
};

export const getFraction = (level) => {
  const maxDenominator =
    level === "beginner"
      ? 5
      : level === "advanced"
      ? 20
      : 10;

  const denominator =
    Math.floor(Math.random() * (maxDenominator - 1)) + 2;

  const numerator =
    denominator +
    Math.floor(Math.random() * denominator) +
    1;

  return `${numerator}/${denominator}`;
};

const toMixedFraction = (fraction) => {
  const [numerator, denominator] =
    fraction.split("/").map(Number);

  const whole = Math.floor(numerator / denominator);
  const remainder = numerator % denominator;

  if (remainder === 0) {
    return `${whole}`;
  }

  const divisor = gcd(remainder, denominator);

  return `${whole} ${remainder / divisor}/${denominator / divisor}`;
};

export const TopPartNumbers = (level) => {
  return [getFraction(level)];
};

export const getNumbers = (level) => {
  const fraction = getFraction(level);

  return [[fraction]];
};

export const getAnswer = (arr1) => {
  return toMixedFraction(arr1[0]);
};

export const getAnswers = (correctAnswer) => {
  const answers = new Set();

  answers.add(correctAnswer);

  while (answers.size < 3) {
    const parts = correctAnswer.split(" ");

    let fakeAnswer;

    if (parts.length === 1) {
      const whole = Number(parts[0]);
    
      if (Math.random() < 0.5) {
        fakeAnswer = `${Math.max(
          1,
          whole + Math.floor(Math.random() * 3) - 1
        )}`;
      } else {
        const den = Math.floor(Math.random() * 4) + 2; 
        const num = Math.floor(Math.random() * (den - 1)) + 1; 
    
        fakeAnswer = `${whole - 1} ${num}/${den}`;
      }
    } else {
      const whole = Number(parts[0]);

      const [num, den] =
        parts[1].split("/").map(Number);

      if (Math.random() < 0.5) {
        fakeAnswer = `${whole + 1} ${num}/${den}`;
      } else {
        const fakeNum = Math.max(
          1,
          num + Math.floor(Math.random() * 3) - 1
        );

        fakeAnswer = `${whole} ${fakeNum}/${den}`;
      }
    }

    answers.add(fakeAnswer);
  }

  return [...answers].sort(
    () => Math.random() - 0.5
  );
};

export const getAnimationValues = () => {
  const values = [Math.random() * 100];

  while (values.length < 5) {
    values.push(
      Math.random() * 100 +
        values[values.length - 1]
    );
  }

  return values;
};

export const getBottomGapX = (state) => {
  
    if (window.innerWidth<440) {
      return (300-5*39)/3;
    }
      if (window.innerWidth>=440 && window.innerWidth<736) {
      return (400-5*39)/3;
    }
    if (window.innerWidth>=736 && window.innerWidth<1024) {
      return (425-5*39)/3;
    }
      if (window.innerWidth>=1024 && window.innerWidth<1440) {
        if (state) {
          return (439-6*39)/3;
        } else {
          return (576-6*49)/3;
        } 
      }
      if (window.innerWidth>=1440 && window.innerWidth<1920) {
        if (state) {
          return (590-6*50)/3;
        } else {
          return (723-6*69)/3;
        } 
      }
      if (window.innerWidth>=1920) {
        if (state) {
          return (768-6*70)/3;
        } else {
          return (909-6*89)/3;
        } 
      }
  }

export const getCoordinates = () => {
  const elem = document.querySelector('.adding');
  const answer = document.querySelector('.answer');
  const x1 = elem.getBoundingClientRect().x;
  const y1 = elem.getBoundingClientRect().y;
  const x2 = answer.getBoundingClientRect().x;
  const y2 = answer.getBoundingClientRect().y;
  const xDistance = x1 - x2;
  const yDistance = y1 - y2;
  return [
      xDistance - (answer.getBoundingClientRect().width - elem.getBoundingClientRect().width) / 2,
      yDistance - (answer.getBoundingClientRect().height - elem.getBoundingClientRect().height) / 2
  ];
}